import { useSyncExternalStore } from 'react';

// Reloj compartido de 1 segundo para los contadores de tiempo (mesas, solicitudes...).
//
// Antes el modulo de Mesas guardaba `Date.now()` en un useState de la pantalla entera y lo actualizaba cada
// segundo: eso redibujaba TODA la pantalla (todas las mesas, el panel lateral, los modales) cada segundo, para
// cambiar solo unos textos "mm:ss". En un Android modesto (o con la CPU limitada por calor tras horas de uso)
// ese redibujado constante llega a ocupar casi todo el hilo principal y la app deja de responder.
//
// Con este hook solo se redibuja el componente que lo usa (un texto), y hay UN solo setInterval para todos:
// arranca con el primer suscriptor y se detiene cuando ya no queda ninguno.
const listeners = new Set();
let intervalId = null;
let current = Date.now();

const tick = () => {
    current = Date.now();
    listeners.forEach((listener) => listener());
};

const subscribe = (listener) => {
    listeners.add(listener);
    if (intervalId === null) {
        current = Date.now();
        intervalId = setInterval(tick, 1000);
    }
    return () => {
        listeners.delete(listener);
        if (listeners.size === 0 && intervalId !== null) {
            clearInterval(intervalId);
            intervalId = null;
        }
    };
};

const getSnapshot = () => {
    // Sin reloj corriendo (nadie suscrito) `current` puede ser muy viejo: se refresca una vez al montar.
    if (intervalId === null && Date.now() - current > 1000) current = Date.now();
    return current;
};
const getDisabledSnapshot = () => 0;
const subscribeNothing = () => () => { };

// enabled=false: no se suscribe (ej. un panel cerrado) y no genera ningun redibujado.
export default function useNowTick(enabled = true) {
    return useSyncExternalStore(
        enabled ? subscribe : subscribeNothing,
        enabled ? getSnapshot : getDisabledSnapshot
    );
}
